module.exports = __webpack_public_path__ + "media/insights/baseball_icon-24dc46f7.png";